import Instance from "./Repository";
const Repository = Instance.auth
const RepositoryNoAuth = Instance.noAuth

const resource = "/api/content";

export default {
	get (type, id){
		return Repository.get(`${resource}/${type}/${id}`);
	},
	getPageByAlias(alias){
		return Repository.get(`/api/alias/${alias}`);
	},

	getWebform(id){
		return Repository.get(`/webform_rest/${id}/fields`);
	},

	searchSite(phrase){
		return Repository.get(`/api/search/${phrase}`);
	},

	submitWebform(formData){
		return RepositoryNoAuth.post(`/webform_rest/submit`, formData);
	},

	// uploadFile(entity_type_id, bundle, field_name, formData, filename){
	// 	return RepositoryNoAuth.post(`/file/upload/${entity_type_id}/${bundle}/${field_name} ?_format=json`, formData, {
	// 		headers: {
	// 			"Content-Type": "application/octet-stream",
	// 			"Content-Disposition": `file; filename=${filename}`
	// 		}
	// 	});
	// },

	getDrupalToken(){
		return RepositoryNoAuth.get(`/rest/session/token`)
	}
};


		